module.exports = function () {
    function DynamicContentProductGroupController(productGroupService) {
        productGroupService.getProducts(this.groupName).then(function (group) {
            this.productGroupExists = group !== undefined;
        }.bind(this));
    }

    return {
        restrict: 'E',
        scope: {
            groupName: '@'
        },
        bindToController: true,
        controllerAs: 'ctrl',
        controller: ['ProductGroupService', DynamicContentProductGroupController],
        template: '<wow-card-list ng-if="ctrl.productGroupExists">' +
            '<oly-dc-product-group-products group-id="ctrl.groupName"></oly-dc-product-group-products>' +
            '</wow-card-list>'
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/dynamiccontent/dynamic-content-product-group-directive.js
 **/